import {ControllableDto} from '@lib/infrastructure';
import {numericCompareAsc, stringCompare} from '@lib/utils';

export const roundToClosest = <T extends number>(num: number, values: readonly T[]): T =>
  values.reduce((prev, curr) => (Math.abs(curr - num) < Math.abs(prev - num) ? curr : prev));

export const ControlValues = {
  temperature: [2, 1, 0, -1, -2] as const,
  blinds: [0, 25, 50, 75, 100] as const,
};

const sortHelper = {
  temperature: -1,
  blinds: 1,
} as const;

export const controlCompare = (a: ControllableDto, b: ControllableDto) => {
  if (a.type === b.type) {
    return stringCompare(a.displayName, b.displayName);
  }

  return numericCompareAsc(sortHelper[a.type], sortHelper[b.type]);
};
